import { useRouter } from "next/router";

import { SUPPORTED_LOCALES } from "@/constants/language-and-locales";

const useUrl = () => {
  const baseUrl = process.env.NEXT_PUBLIC_URL;
  const router = useRouter();
  const { asPath, locale, defaultLocale } = router;
  const getLangPathPrefix = (_locale) =>
    _locale === defaultLocale ? "" : `/${_locale}`;

  // If path is empty, remove the slash
  const normalisedPath = asPath === "/" ? "" : asPath;

  const generateHreflangUrls = () => {
    return SUPPORTED_LOCALES.map((lang) => ({
      lang,
      url: `${baseUrl}${getLangPathPrefix(lang)}${normalisedPath}`,
    }));
  };

  const currentUrl = `${baseUrl}${getLangPathPrefix(locale)}${normalisedPath}`;

  return {
    currentUrl,
    baseUrl,
    generateHreflangUrls,
    langPathPrefix: getLangPathPrefix(locale),
  };
};

export default useUrl;
